export const CALC_DEFAULTS = {
    lots: '100',
    sub: '1000',
};

export const CALC_LIMITS = {
    lots: { min: 0, max: 1000000 },
    sub: { min: 0, max: 1000000000 },
};

const MONEY_LOCALES = {
    en: 'en-US',
    es: 'es-ES',
    pt: 'pt-BR',
    id: 'id-ID',
};

export function parseCalcInput(raw, { min, max }) {
    const value = String(raw ?? '').trim();
    if (!value || !/^\d+(\.\d+)?$/.test(value)) return null;
    const amount = Number(value);
    if (!Number.isFinite(amount) || amount < min || amount > max) return null;
    return amount;
}

export function calculateIncome(lots, subIncome) {
    const rebate = lots * 18;
    const override = subIncome * 0.15;
    const bonus = Math.floor(lots / 100) * 100;
    return {
        rebate,
        override,
        bonus,
        total: rebate + override + bonus,
        other: lots * 22 * 0.2,
    };
}

export function formatLandingUsd(amount, locale) {
    return new Intl.NumberFormat(MONEY_LOCALES[locale] || MONEY_LOCALES.en, {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(amount);
}
